import React from 'react';
import { useNavigate } from "react-router-dom"

const NotFound = () => {
  const navigate = useNavigate();
  
  return (
    <div className="notfound-wrap">
      <div className="notfound-hero">
        <span className="glitch" aria-hidden="true">404</span>
        <span className="glitch" aria-hidden="true">404</span>
        <span className="glitch">404</span>
      </div>

      <p className="notfound-sub">Oops! This page drifted into the void.</p>

      <div className="notfound-actions">
        <button className="btn" onClick={() => navigate("/")}>
          Go Home
        </button>
        <button className="btn ghost" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>

      <div className="orb" aria-hidden="true" />
    </div>
  );
}

export default NotFound;